"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const options_1 = require("../options");
async function default_1(session, resetStore = true) {
    const { apolloClient, saveSession, wsClient } = (0, options_1.getOptions)();
    if (resetStore) {
        await apolloClient.clearStore();
    }
    await saveSession(session);
    if (resetStore) {
        await apolloClient.reFetchObservableQueries();
    }
    if (wsClient) {
        wsClient.tryReconnect();
    }
}
exports.default = default_1;
